import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchCasesDirective } from './switch-cases.directive';

@NgModule({
  declarations: [SwitchCasesDirective],
  imports: [CommonModule],
  exports: [SwitchCasesDirective],
})
export class SwitchCasesModule {}
